import React from "react";

export const ImagePreloaderStatusContext = React.createContext({
  initialVideoCanPlayThroughReceived: false,
  notifyInitialVideoCanPlayThroughReceived: () => {
    throw new Error("override this");
  },
});
